import { xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Card = xcss({
  padding: 'space.250',
  width: '320px',
  gap: 'space.150',
  borderRadius: 'border.radius.100',
  boxShadow: 'elevation.shadow.raised',
  backgroundImage: `linear-gradient(to bottom, ${token(
    'color.background.neutral',
    colors.N20
  )} 0%, ${token('color.background.neutral', colors.N20)} 50%)`,
  backgroundSize: '100% 48px',
  backgroundRepeat: 'no-repeat',
});

export const IconBackground = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'color.background.warning.bold',
  borderRadius: 'border.radius.circle',
  height: 'size.500',
  width: 'size.500',
});

export const Content = xcss({
  width: '224px',
  gap: 'space.100',
});
